import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ScreenerAnswer } from "@src/services/screener-answers.service";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the screener-answers endpoint.
 */
export function buildScreenerAnswersConfig(
  userUuid: string,
  answers: ScreenerAnswer[],
  signal?: AbortSignal,
): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.SCREENER_ANSWERS,
    body: { user_uuid: userUuid, answers } as Record<string, unknown>,
    ...(signal ? { signal } : {}),
  };
}
